module.exports = {
  build: require("./build"),
  fill: require("./fill"),
  resolve: require("./resolve")
};
